const path = {
    // local: 'https://cartify-backend-production.up.railway.app',
    // local : 'http://localhost:4000',
    local: 'https://cartify-backend.onrender.com',
    remote: 'https://cartify-backend.herokuapp.com',
}

export default path;